<template>
    <v-card v-if="isVisible" class="mb-4" :loading="isLoading">
        <v-card-title>Hai, {{ $store.get('auth/name') }}</v-card-title>

        <v-card-text>
            <v-window :value="window">
                <v-window-item>
                    Apa pendapatmu tentang try out yang dirilis secara berkala seperti di bawah?
                </v-window-item>

                <v-window-item>
                    Apakah kamu punya pendapat lain tentang soal try out yang mediko berikan?

                    <v-textarea
                        v-model="description"
                        placeholder="Kritik atau saran kamu"
                    ></v-textarea>

                    <v-btn
                        @click="sendDescription"
                        color="primary"
                        :disabled="! description"
                    >Kirim</v-btn>
                    <v-btn
                        @click="sendDescription"
                        text
                        :disabled="!! description"
                    >tidak ada</v-btn>
                </v-window-item>

                <v-window-item>
                    <v-list-item-avatar>
                        <v-icon>mdi-thumb-up</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>
                            Terima kasih telah mengisi survey ini
                        </v-list-item-title>
                    </v-list-item-content>
                </v-window-item>
            </v-window>
        </v-card-text>

        <v-card-actions v-if="window == 0">
            <v-btn
                @click="sendResponse('dislike')"
                text
                color="red"
            >
                tidak suka
            </v-btn>
            <v-btn
                @click="sendResponse('neutral')"
                text
            >
                biasa saja
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
const PERIOD_ID = 47
const STATE_EMTPY = 1
const STATE_HAS_RESPONSE = 2
const STATE_SURVEY_FINISHED = 3
const STATE_HAS_DESCRIPTION = 4

export default {
    props: {
        tryouts: {
            type: Array
        }
    },

    data: () => ({
        state: null,
        isLoading: false,
        description: ''
    }),

    computed: {
        isVisible() {
            return this.$store.get('enrollment/selected@id') == PERIOD_ID
                && this.state != STATE_HAS_DESCRIPTION
                && this.releasedTryoutCount < 7
        },
        window() {
            return this.state - 1
        },
        releasedTryoutCount() {
            if (! this.tryouts) {
                return 0
            }

            return this.tryouts
                .filter(tryout => tryout.is_released)
                .length
        }
    },

    methods: {
        async sendResponse(responseText) {
            this.isLoading = true
            await this.$apiv2.post('tryout-late-release-survey/response', {
                response: responseText
            })
            this.isLoading = false

            this.state = STATE_HAS_RESPONSE
        },

        async sendDescription() {
            this.isLoading = true
            await this.$apiv2.post('tryout-late-release-survey/description', {
                description: this.description
            })
            this.isLoading = false

            this.state = STATE_SURVEY_FINISHED
        }
    },

    async created() {
        const response = await this.$apiv2.get('tryout-late-release-survey/status')
        const data = response.data

        if (! data) {
            this.state = STATE_EMTPY
            return
        }

        if (data.description == '' || data.description) {
            this.state = STATE_HAS_DESCRIPTION
        } else if (data.response) {
            this.state = STATE_HAS_RESPONSE
        }
    }
}
</script>
